// Followup Suggestions — friendly "what to ask next" panel

import React from 'react';
import { ArrowRight, BarChart3, LineChart, PieChart, TrendingUp, Search, MessageCircle } from 'lucide-react';
import { COLORS } from '../../constants/theme';

// Pick an icon that matches the question intent
const getConfig = (text) => {
  const t = text.toLowerCase();
  if (/\b(pie|donut|share|portion|breakdown|distribution)\b/.test(t))
    return { icon: PieChart,   color: '#8B5CF6', emoji: '🥧' };
  if (/\b(bar chart|bar graph|top|ranked|highest|compare)\b/.test(t))
    return { icon: BarChart3,  color: '#3B82F6', emoji: '📊' };
  if (/\b(trend|over time|month|line|growth|increase|decrease)\b/.test(t))
    return { icon: LineChart,  color: '#10B981', emoji: '📈' };
  if (/\b(why|reason|cause|explain|how come)\b/.test(t))
    return { icon: MessageCircle, color: '#F59E0B', emoji: '🤔' };
  if (/\b(total|sum|spend|cost|amount|value)\b/.test(t))
    return { icon: TrendingUp, color: '#EF4444', emoji: '💰' };
  return { icon: Search, color: COLORS.primary, emoji: '🔍' };
};

const FollowupSuggestions = ({ suggestions, onSuggestionClick, disabled = false }) => {
  if (!suggestions?.length) return null;

  return (
    <div className="mt-5 animate-fade-in-up">
      {/* Section heading */}
      <div className="flex items-center gap-2 mb-3">
        <span className="text-base">💬</span>
        <span className="text-sm font-semibold text-gray-600">Ask a follow-up</span>
      </div>

      {/* Question buttons */}
      <div className="space-y-2">
        {suggestions.map((suggestion, idx) => {
          const { icon: Icon, color, emoji } = getConfig(suggestion);
          return (
            <button
              key={idx}
              disabled={disabled}
              onClick={() => onSuggestionClick(suggestion)}
              className="group w-full flex items-center gap-3 text-left px-4 py-3.5 rounded-2xl bg-white border border-gray-200 hover:border-blue-300 hover:bg-gradient-to-r hover:from-blue-50 hover:to-indigo-50 transition-all duration-200 shadow-sm hover:shadow-md disabled:opacity-50 disabled:pointer-events-none"
            >
              {/* Emoji bubble */}
              <span
                className="flex-shrink-0 w-9 h-9 rounded-xl flex items-center justify-center text-lg transition-transform duration-200 group-hover:scale-110"
                style={{ backgroundColor: `${color}15` }}
              >
                {emoji}
              </span>

              {/* Question text */}
              <span className="flex-1 text-[15px] text-gray-700 group-hover:text-blue-900 leading-snug font-normal transition-colors duration-200">
                {suggestion}
              </span>

              {/* Arrow — appears on hover */}
              <ArrowRight className="flex-shrink-0 w-4 h-4 text-gray-300 group-hover:text-blue-400 opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all duration-200" />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default FollowupSuggestions;
